export var ellipsis = function ellipsis() {
  var maxWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '100%';
  var unit = typeof maxWidth === 'number' ? 'px' : '';
  return "\n    max-width: ".concat(maxWidth).concat(unit, ";\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  ");
};
export var size = function size() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '100%';
  var unit = typeof value === 'number' ? 'px' : '';
  return "\n    width: ".concat(value).concat(unit, ";\n    height: ").concat(value).concat(unit, ";\n  ");
};
export var center = "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n";
export var absolute = function absolute() {
  var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var left = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return "\n  position: absolute;\n  top: ".concat(top, "px;\n  left: ").concat(left, "px;\n");
};
export var borderRadius = "\n  border-radius: ".concat("var(--ds-radius-small, 3px)", ";\n");
export var borderRadiusBottom = "\n  border-bottom-left-radius: ".concat("var(--ds-radius-small, 3px)", ";\n  border-bottom-right-radius: ", "var(--ds-radius-small, 3px)", ";\n");
export var easeInOutCubic = 'cubic-bezier(0.645, 0.045, 0.355, 1)';